module.exports = __webpack_public_path__ + "img/bg02.fa847fff.gif";